import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

export const DIGITAL_RECEIVING_VERBS: BehavioralVerb[] = createOptions([
  'Bookmarking',
  'Googling',
  'Highlighting',
  'Listening',
]);

export const DIGITAL_RESPONDING_VERBS: BehavioralVerb[] = createOptions([
  'Commenting',
  'Journaling',
  'Posting',
  'Tagging',
  'Tweeting',
]);

export const DIGITAL_VALUING_VERBS: BehavioralVerb[] = createOptions([
  'Defending',
  'Expressing',
  'Reflecting',
  'Supporting (a cause)',
]);

export const DIGITAL_ORGANIZING_VERBS: BehavioralVerb[] = createOptions([
  'Appraising',
  'Comparing',
  'Contrasting',
  'Integrating',
  'Prioritizing',
  'Reviewing',
]);

export const DIGITAL_CHARACTERIZING_VERBS: BehavioralVerb[] = createOptions([
  'Collaborating',
  'Facilitating',
  'Leading',
  'Moderating',
  'Negotiating',
]);
